import { Renderer } from "@with-nx/cms-ui";
import { Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";

import LegalMenuDesktop from "../../components/w/LegalMenuDesktop";

export default function Page() {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Code of Conduct"
      description="This Code of Conduct document was last updated on December 17, 2020"
    >
      <ReusableSection>
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="space-between">
            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
              <LegalMenuDesktop />
            </Col>
            <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Rule rule="hs" color="var(--font1)" display="block" bottom={24}>
                Code of Conduct
              </Rule>
              <Rule rule="ls" color="var(--font3)" display="block" bottom={24}>
                This Code of Conduct document was last updated on December 17,
                2020
              </Rule>
              <Renderer
                data={{
                  blocks: [
                    {
                      type: "paragraph",
                      data: {
                        text: `BMD’s community comments to blog posts, customer reviews, social media and other related discussion-oriented digital platforms involves participants with a wide range of beliefs and ideas about the subjects they’re discussing.`,
                      },
                    },
                    {
                      type: "list",
                      data: {
                        text: [
                          `Customer and guest interaction with BMD products, services and materials is meant to be a positive experience for anyone who chooses to participate. Feel free to post helpful and relevant advice or suggestions, but do not be abusive, profane, threatening, or offensive. Think before you post. Is it necessary? Is it kind? Is it true?`,
                          `Use caution when discussing products not offered by BMD or discussing overtly negative remarks about BMD or its products or services. Information posted on any BMD property, services or offerings are available for all to see, and comments are subject to libel, slander, and antitrust laws.`,
                          `No commercial messages or advertisements not directly benefiting BMD are permitted.`,
                          `BMD has the right to reproduce postings and content unless you specify otherwise.`,
                          `Before responding to a post, read all comments to be sure duplicate information isn’t submitted.`,
                          `Be as concise as possible and stay on topic.`,
                          `On the internet, you always have an audience. This means you are accountable for your own actions. Anything you post is instantly available for the world to see.`,
                          `Respect the privacy of others. BMD is not responsible for any consequences you experience resulting from anything you have posted on our website(s).`,
                          `BMD reserves the right to update or change these guidelines without notice; be sure you keep up to date.`,
                          `If it’s not your copyright, get permission before you post it, or cite the necessary sources.`,
                          `BMD is not responsible for the opinions and information posted on this site by others.`,
                          `BMD disclaims all warranties with regard to information posted on this site, whether posted by BMD or any third party; this disclaimer includes all implied warranties of merchantability and fitness, as well as any warranties of accuracy or noninfringement.`,
                          `In no event BMD be liable for any special, indirect, or consequential damages or any damages whatsoever resulting from loss of use, data, or profits, arising out of or in connection with the use, disclosure or performance of any information posted on this site.`,
                          `Users are not allowed to post any defamatory, abusive, profane, threatening, offensive, or illegal materials.`,
                          `Users are not allowed to engage in behavior that constitutes discrimination or harassment in any way, including race, color, or nationality.  `,
                          `Users should not post any information or other material protected by copyright without the permission of the copyright owner. By posting material, the posting party warrants and represents that he or she owns the copyright with respect to such material or has received permission from the copyright owner. In addition, the posting party grants to BMD and all users of this site a perpetual, royalty free, worldwide, nonexclusive right and license to display, copy, publish, distribute, transmit, print, and use such information or other material in all media now known or hereafter invented.`,
                          `BMD supports and abides by the Digital Millennium Copyright Act (DMCA) of 1998. If a member asserts that a copyrighted item has been posted, a written notification must be made (fax, mail, email). The notice should include sufficient detail regarding the copyrighted work and documentation regarding the claim.`,
                          `It is each user’s responsibility to familiarize themselves with any local rules, regulations, or policies regarding online participation through their school or employer.`,
                          `Messages should not be posted if they encourage or facilitate members to engage in unlawful conduct of any sort.`,
                          `Messages should not be posted if they encourage or facilitate members to engage in unlawful conduct of any sort.`,
                        ],
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `BMD does not actively monitor the site for inappropriate postings and does not on its own undertake editorial control of postings. However, in the event that any inappropriate posting is brought to the attention of BMD, we will take all appropriate action.`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `This Code of Conduct may be updated at any time. We reserve the right to terminate or restrict the access of any user who does not abide by these guidelines.      `,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Questions may be addressed by contacting BMD directly.`,
                      },
                    },
                  ],
                }}
              />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}
